import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { MINTING_ERROR_ACTIONS } from '@soundxyz/utils/constants/logging';
import { ToggleGroup } from '@components/basics/ToggleGroup';
import type { SelectedMintPanel } from '@components/modals/Buy/Checkout/TiersCheckouModal';
import { useLogError } from '@hooks/useLogErrorNew';
import { ToggleItem } from '../ToggleItem';

export const TiersToggle = ({
  onValueChange,
  valueState,
  presaleEligible,
}: {
  valueState: SelectedMintPanel;
  onValueChange: React.Dispatch<SelectedMintPanel>;
  presaleEligible: boolean;
}) => {
  const logError = useLogError();

  return (
    <ToggleGroup
      value={valueState}
      onValueChange={value => {
        if (!value) return;
        try {
          const val = value as SelectedMintPanel;
          onValueChange(val);
        } catch {
          logError({
            message: 'Invalid toggle value',
            error: new Error(`Invalid value for TiersToggle: ${value}`),
            errorType: 'UNKNOWN',
            pillar: 'MINTING',
            level: 'error',
            action: MINTING_ERROR_ACTIONS.EDITION_MINT_ERROR,
            isArtistOnlyPage: false,
          });
        }
      }}
      type="single"
      className="!rounded-full !bg-base300 !p-1"
    >
      <ToggleItem
        value="VIP_PRESALE"
        onClick={() => {
          onValueChange('VIP_PRESALE');
        }}
        className="flex items-center gap-1 [&_.check]:data-[state=off]:text-base400 [&_.check]:data-[state=on]:text-fuchsia500 [&_.x]:data-[state=off]:text-base400 [&_.x]:data-[state=on]:text-warning400"
      >
        {presaleEligible && (
          <FontAwesomeIcon icon={faCircleCheck} className="check" fontSize={14} />
        )}
        Presale
      </ToggleItem>
      <ToggleItem
        value="VIP_PUBLIC"
        onClick={() => {
          onValueChange('VIP_PUBLIC');
        }}
      >
        Public Sale
      </ToggleItem>
    </ToggleGroup>
  );
};
